<template>
<div class="container" style="margin-top:100px;">
  <div class="row">
    <div class="col-sm-6 col-sm-offset-3">
      <div class="panel panel-primary">
        <div class="panel-heading">
          <h3 class="panel-title">登录</h3>
        </div>
        <div class="panel-body">
          <div class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-3 control-label">账号</label>
              <div class="col-sm-8">
                <input type="text" class="form-control" placeholder="请输入用户名或手机号" v-model="user.loginId" :disabled="disableLoginId">
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">密码</label>
              <div class="col-sm-8">
                <input type="password" class="form-control" placeholder="请输入密码" v-model="user.password" :disabled="disablePassword">
              </div>
            </div>
            <div class="form-group">
              <div class="col-sm-8 col-sm-offset-3">
                <btn type="danger" @click="doLogin">登录</btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import * as TYPES from '../store/types'
export default {
  data() {
    return {
      open: true,
      user: {
        loginId: '',
        password: ''
      },
      title: '',
      content: '',
      show: false,
      disableLoginId: false,
      disablePassword: false
    }
  },
  mounted() {
    if (localStorage.token !== '' && localStorage.token !== null && typeof localStorage.token !== 'undefined') {
      this.$router.push('/search')
    }
    this.user.loginId = this.$route.query.loginId
    this.user.password = this.$route.query.password

    this.disableLoginId = typeof this.$route.query.loginId !== 'undefined'
    this.disablePassword = typeof this.$route.query.password !== 'undefined'
  },
  methods: {
    doLogin() {
      this.$store
        .dispatch(TYPES.DO_LOGIN, {
          username: this.user.loginId,
          password: this.user.password
        })
        .then(res => {
          console.log(res)
          if (res.data.ok) {
            this.$router.push('/search')
            this.$center.start()
            .then(res => console.log('登陆后重新连接message center成功！'))
            .catch(res => console.log('登陆后重新连接message center失败！'))
          } else {
            this.$notify({
              type: 'danger',
              content: '登录失败'
            })
          }
        })
        .catch(res => {
          console.log(res)
          this.$notify({
            type: 'danger',
            content: '登录失败'
          })
        })
    }
  }
}
</script>

<style>
.modal-backdrop{
  z-index: 10 !important;
}
.modal {
  z-index: 12 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue